import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

export const NotificationBadge = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUnreadCount = async () => {
      const { data: session } = await supabase.auth.getSession();
      if (!session.session) {
        navigate('/login');
        return;
      }

      const { data, error } = await supabase
        .from('notifications')
        .select('id')
        .eq('read', false)
        .eq('user_id', session.session.user.id);
      
      if (error) {
        console.error('Error fetching notifications:', error);
        return;
      }
      
      setUnreadCount(data?.length || 0);
    };

    fetchUnreadCount();

    const channel = supabase
      .channel('notifications_changes')
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'notifications'
        },
        () => {
          fetchUnreadCount();
        }
      )
      .subscribe();

    return () => {
      channel.unsubscribe();
    };
  }, [navigate]);

  if (unreadCount === 0) return null;

  return (
    <span className="absolute -top-1 -right-1 h-4 w-4 bg-accent rounded-full text-xs text-white flex items-center justify-center">
      {unreadCount}
    </span>
  );
};